<template>
    <div class="">
        <div class="cards-grid">
            <NewsCard v-for="(item, index) in transformedItems" :show-deals="true" :key="index" :tag="item.city" :item="item"
            />
        </div>

        <div v-if="!lastPage" class="text--center mt-medium">
            <BaseButton
                modifier="medium"
                tag="button"
                @click="refineNext"
            >
                View more
            </BaseButton>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    name: 'AlgoliaEventsGrid',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        refineNext: {
            type: Function
        },
        lastPage: {
            type: Boolean,
            required: true
        },
        fallbackImage: {
            type: String
        }
    },
    computed: {
        transformedItems() {
            return this.items.map((i) => {
                if (i.transformed) return i;

                const dates = i.productEventDates.length ? {
                    displayDate: {
                        day: moment(i.productEventDates[0], 'X').format("D"),
                        month: moment(i.productEventDates[0], 'X').format("MMM")
                    },
                    displayStartDate: {
                        day: moment(i.productEventDates[0], 'X').format("D"),
                        month: moment(i.productEventDates[0], 'X').format("MMM")
                    },
                    displayEndDate: {
                        day: moment(i.productEventDates[i.productEventDates.length - 1], 'X').format("D"),
                        month: moment(i.productEventDates[i.productEventDates.length - 1], 'X').format("MMM")
                    }
                } : {};

                const image = i.image[0] == '' ? this.fallbackImage : i.image[0];

                return {
                    title: i.title,
                    image,
                    ...dates,
                    ratio: 1,
                    url: i.uri,
                    transformed: true,
                    city: i.productLocations ? i.productLocations[0].city : null
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
    .cards-grid {
        display: flex;
        flex-wrap: wrap;
    }
    .NewsCard {
        width: 50%;
        flex-grow: 0;

        &::v-deep .image {
            object-fit: cover;
        }

        @include media-query(lap-and-up) {
            width: 33.33%;
        }
    }
</style>
